import { render } from "./ambiente-coordenador-layout.vue?vue&type=template&id=7117bd0a"
import script from "./ambiente-coordenador-layout.vue?vue&type=script&lang=js"
export * from "./ambiente-coordenador-layout.vue?vue&type=script&lang=js"

import "./ambiente-coordenador-layout.vue?vue&type=style&index=0&id=7117bd0a&lang=scss"
import "./ambiente-coordenador-layout.vue?vue&type=style&index=1&id=7117bd0a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__